const localState = {
    showModal: false,
    form: {
        to: '',
        subject: '',
        message: '',
    },
}

const mutations = {
    setShowModal: (state) => {
        state.showModal = !state.showModal
    },
    setEmail: (state, v) => {
        state.form.to = v
    },
    setFile: (state, v) => {
        state.form.file = v
    },
    clearForm: (state) => {
        state.form = {
            to: '',
            subject: '',
            message: '',
        }
    },
}

const getters = {
    showModalGetters: (state) => state.showModal,
    formGetters: (state) => state.form,
}

const actions = {
    async send({
        state,
        commit,
    }) {
        try {
            const fd = new FormData()
            fd.append('to', state.form.to)
            fd.append('subject', state.form.subject)
            fd.append('message', state.form.message)

            if (state.form.file !== undefined) {
                fd.append('file', state.form.file)
            }

            const response = await this.$api.specialists.sendMail(fd)

            if (response.status === 204) {
                commit('setShowModal')
                return true
            }
        } catch (err) {
            console.log(err)
        }
    },
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    getters,
    actions,
}
